var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 29,
    height: 28,
    rx: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8337 12.8333H19.8337V11.64C19.8337 9.89997 18.5603 8.34664 16.827 8.17997C14.8403 7.9933 13.167 9.5533 13.167 11.5V12.8333H11.167V22.1666H21.8337V12.8333ZM16.5003 18.8333C15.767 18.8333 15.167 18.2333 15.167 17.5C15.167 16.7666 15.767 16.1666 16.5003 16.1666C17.2337 16.1666 17.8337 16.7666 17.8337 17.5C17.8337 18.2333 17.2337 18.8333 16.5003 18.8333ZM14.5003 12.8333V11.5C14.5003 10.3933 15.3937 9.49997 16.5003 9.49997C17.607 9.49997 18.5003 10.3933 18.5003 11.5V12.8333H14.5003Z",
    fill: "#898E9C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 29,
    height: 28,
    rx: 14,
    stroke: "#C2C4C8",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.f02b15363fac0127dc02483a7ed6e6aa.svg";
export { ForwardRef as ReactComponent };